import React from 'react';
import {Col, Container, Row, Nav, Tab, Accordion} from "react-bootstrap";

function Consulting(props) {
    return (
        <section className="tekgrip_section  p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
                        <div className="example" data-text="Hire TekRevol's">
                            <h2>Why Hire TekRevol’s HTML5 Developer</h2>
                        </div>
                        <div
                            className="main_para"><p>We have a streak of successful projects developed using HTML, and HTML5 has just been added to the list. Its high-end front-end and UI performance, more control, and flexibility in development and cross-browser support have helped us bring innovative tech ideas to digital reality.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs deskstop_version">
                        <Tab.Container id="" defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Portfolio of HTML5 Projects</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Modern Tech</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">Agile Approach</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="3">Dedicated Development</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Tab.Content>

                                        <Tab.Pane eventKey="0">
                                            <p>We have a streak of successful projects developed using HTML, and HTML5 has just been added to the list. Its high-end front-end and UI performance, more control, and flexibility in development and cross-browser support have helped us bring innovative tech ideas to digital reality.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>Our developers for HTML5 development services are well-versed with other revolutionary technologies currently impacting the global business ecosystem. We have development departments with blockchain engineers, cloud architects, machine learning and data scientists, and IoT developers. </p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>Whether hiring TekRevol’s HTML5 developer or working on a staff augmentation model by handpicking multiple development professionals of your choice, you will experience high levels of project transparency and control at every development step. That’s because we follow agile development methodologies and build and test in real time.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="3">
                                            <p>We are proud of our people, processes, and portfolio. For years, we have created the right intersection of talent and technologies, which has helped us build the best digital products and unmatchable experiences.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Col>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="mobile_version">
                        <div className="tekrevol_mobile_accordion">
                            <Accordion
                                defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Portfolio of HTML5 Projects</Accordion.Header>
                                    <Accordion.Body>
                                        <p>We have a streak of successful projects developed using HTML, and HTML5 has just been added to the list. Its high-end front-end and UI performance, more control, and flexibility in development and cross-browser support have helped us bring innovative tech ideas to digital reality.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Modern Tech</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Our developers for HTML5 development services are well-versed with other revolutionary technologies currently impacting the global business ecosystem. We have development departments with blockchain engineers, cloud architects, machine learning and data scientists, and IoT developers. </p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>Agile Approach</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Whether hiring TekRevol’s HTML5 developer or working on a staff augmentation model by handpicking multiple development professionals of your choice, you will experience high levels of project transparency and control at every development step. That’s because we follow agile development methodologies and build and test in real time.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>Dedicated Development</Accordion.Header>
                                    <Accordion.Body>
                                        <p>We are proud of our people, processes, and portfolio. For years, we have created the right intersection of talent and technologies, which has helped us build the best digital products and unmatchable experiences.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Consulting;